import 'react-intl-tel-input/dist/main.css';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import IntlTelInput from 'react-intl-tel-input';
import { translate } from 'react-i18next';
import moment from 'moment';
import { pick } from 'lodash/object';
import { Grid, Row, Col, Button } from 'react-bootstrap';
import TimeSlotCard from '../TimeSlotCard/';
import { reservationReasonTextMaxLength } from '../../util/constants';

class ConfirmTimeSlotForm extends PureComponent {
  constructor(props) {
    super(props);
    this.handleFormInputChange = this.handleFormInputChange.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handlePhoneInputChange = this.handlePhoneInputChange.bind(this);
    this.handleEmailInputChange = this.handleEmailInputChange.bind(this);
    this.validateFields = this.validateFields.bind(this);
    this.emailConfirmationEnabled = this.emailConfirmationEnabled;
    this.smsConfirmationEnabled = this.smsConfirmationEnabled;
    this.state = {
      submitButtonDisabled: true,
      reasonText: '',
      phone: '',
      email: '',
      isReasonTextValid: false,
      isPhoneValid: false,
      isEmailValid: false,
      showPhoneValidation: false,
      showEmailValidation: false
    };
  }

  isPhoneValid(phone) {
    const telUtils = window.intlTelInputUtils;
  
    const numberType = phone && telUtils.getNumberType(phone);
    const telUtilsValidation = phone && telUtils.isValidNumber(phone) &&
                                (numberType === telUtils.numberType.MOBILE || numberType === telUtils.numberType.FIXED_LINE_OR_MOBILE);
    const specialCase = phone && phone.replace(/\s/g, '').startsWith('+358299') && phone.replace(/\s/g, '').length > 9;
    return !!(!this.props.smsConfirmationEnabled || (telUtilsValidation || specialCase));
  }

  isEmailValid(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return !!(!this.props.emailConfirmationEnabled || (email && re.test(String(email).toLowerCase())));
  }

  handlePhoneInputChange(status, inputVal, countryData, number) {
    const fieldName = 'phone';
    const value = number.replace(/\s/g, '');
    this.setState({ [fieldName]: value }, this.validateFields);

    const isPhoneValid = this.isPhoneValid(number);
    const showPhoneValidation = !isPhoneValid && inputVal.length > 0;
    this.setState({ showPhoneValidation });
  }

  handleFormInputChange(event) {
    const { id: fieldName, value } = event.target;
    this.setState({ [fieldName]: value }, this.validateFields);
  }

  handleEmailInputChange(event) {
    const { id: fieldName, value } = event.target;
    const isEmailValid = this.isEmailValid(value);
    const showEmailValidation = !isEmailValid && value.length > 0;
    this.setState({ showEmailValidation });
    this.setState({ [fieldName]: value }, this.validateFields);
  }

  handleConfirm() {
    // prevent multiple clicks
    this.state.submitButtonDisabled = true;
    const formValues = pick(this.state, ['reasonText', 'phone', 'email']);
    this.props.onConfirm(this.props.timeSlot, formValues);
  }

  isEmptyField(string) {
    return !string || string.trim() === '';
  }

  validateFields() {
    // TODO: Validations.
    const { reasonText, phone, email } = this.state;
    const { optionalReservationText, smsConfirmationEnabled, emailConfirmationEnabled } = this.props;
    const isReasonTextValid = optionalReservationText || reasonText.length > 0;
    const isPhoneValid = this.isPhoneValid(phone);
    const isEmailValid = this.isEmailValid(email);
    let submitButtonDisabled = true;

    // validate with OR logic but check is there validation errors if both fields used
    if (smsConfirmationEnabled && emailConfirmationEnabled) {
      // either phone or email are valid, if both field are filled, then both should be valid
      const emailIsValidOrEmpty = this.isEmptyField(email) || isEmailValid;
      const phoneIsValidOrEmpty = this.isEmptyField(phone) || isPhoneValid;
      submitButtonDisabled = !isReasonTextValid || !((isPhoneValid && emailIsValidOrEmpty) || (isEmailValid && phoneIsValidOrEmpty));
    } else if (smsConfirmationEnabled && !emailConfirmationEnabled) {
      submitButtonDisabled = !isReasonTextValid || !isPhoneValid;
    } else if (!smsConfirmationEnabled && emailConfirmationEnabled) {
      submitButtonDisabled = !isReasonTextValid || !isEmailValid;
    } else if (!smsConfirmationEnabled && !emailConfirmationEnabled) {
      // phone and email are not shown, check reasonTextValidation only
      submitButtonDisabled = !isReasonTextValid;
    }

    this.setState({
      isReasonTextValid,
      isPhoneValid,
      isEmailValid,
      submitButtonDisabled
    });
  }

  render() {
    const { t, optionalReservationText, smsConfirmationEnabled, emailConfirmationEnabled } = this.props;
    const checkForPhone = this.state.isPhoneValid && smsConfirmationEnabled;
    const checkForEmail = this.state.isEmailValid && emailConfirmationEnabled;
    return (
      <div>
        <form className="confirm-form" onSubmit={(e) => { e.preventDefault() }}>
          <Grid fluid>
            <Row>
              <Col xs={12} sm={6} md={6} lg={6} className="reservation-reason-text-container">
                <div>
                  <label htmlFor="reasonText" className={optionalReservationText ? '' : 'is-required'}>
                    {t('confirmForm.reasonTextLabel', { maxLength: reservationReasonTextMaxLength })}
                  </label>
                  <textarea
                    id="reasonText"
                    className={`reservation-reason ${!optionalReservationText && this.state.isReasonTextValid ? 'is-valid' : ''}`}
                    maxLength={reservationReasonTextMaxLength}
                    rows={2}
                    placeholder={t('confirmForm.reasonTextPlaceholder')}
                    onChange={this.handleFormInputChange}
                  />
                </div>
              </Col>
              <Col xs={12} sm={6} md={6} lg={6} className="reservation-phone-number-container">
                { smsConfirmationEnabled &&
                  <div>
                    <label htmlFor="phone" className="is-required">
                      {t('confirmForm.phoneNumberLabel')}
                    </label>
                    <IntlTelInput
                      fieldId={'visiblePhone'}
                      numberType={'MOBILE'}
                      preferredCountries={['fi', 'se', 'ee']}
                      style={{ width: '100%' }}
                      onPhoneNumberChange={this.handlePhoneInputChange}
                      onPhoneNumberBlur={this.handlePhoneInputChange}
                      useMobileFullscreenDropdown={false}
                      placeholder={t('confirmForm.phoneNumberPlaceholder')}
                      inputClassName={`form-control ${this.state.isPhoneValid ? 'is-valid' : ''}`}
                    />
                  </div>
                }
                { smsConfirmationEnabled &&
                  <div className={`is-required ${this.state.showPhoneValidation && (this.state.phone.length > 5 || checkForEmail) ? '' : 'hidden'}`}>
                    {t('confirmForm.phoneNotValid')}
                  </div>
                }
                { emailConfirmationEnabled &&
                  <div style={{ marginTop: '1em' }}>
                    <label className="is-required" htmlFor="email">{t('reservationDone.emailLabel')}</label>
                    <input
                      id="email"
                      type="text"
                      placeholder={t('reservationDone.emailPlaceholder')}
                      onChange={this.handleEmailInputChange}
                      inputClassName={`form-control ${this.state.isEmailValid ? 'is-valid' : ''}`}
                    />
                  </div>
                }
                { emailConfirmationEnabled &&
                  <div className={`is-required ${this.state.showEmailValidation && (this.state.email.length > 5 || checkForPhone) ? '' : 'hidden'}`}>
                    {t('confirmForm.emailNotValid')}
                  </div>
                }
              </Col>
            </Row>
            { !optionalReservationText &&
            <Row className={`${this.state.isEmailValid || this.props.smsConfirmationEnabled ? 'hidden' : ''}`}>
              <Col xs={12} sm={6} md={6} lg={6}>
                <p className="is-required">{t('requiredFieldInfo')}</p>
              </Col>
              <Col className={`${!this.state.isEmailValid && !this.props.smsConfirmationEnabled ? 'hidden' : ''}`} xs={12} sm={6} md={6} lg={6}>
                <p className="is-required">{t('requiredFieldInfo')}</p>
              </Col>
            </Row>
            }
          </Grid>
        </form>
        <TimeSlotCard
          large
          disabled={this.state.submitButtonDisabled}
          timeSlot={this.props.timeSlot}
          unit={this.props.unit}
          onClick={this.handleConfirm}
          actionElement={<span className="time-slot-action-text">{t('confirmForm.confirm')}</span>}
        />
        <Button
          bsStyle="link"
          className="basic-action-link cancel-confirm-link center-block"
          onClick={this.props.onCancel}
        >
          {t('confirmForm.cancel')}
        </Button>
      </div>
    );
  }
}

ConfirmTimeSlotForm.propTypes = {
  timeSlot: PropTypes.shape({
    timeMoment: PropTypes.instanceOf(moment).isRequired,
    unit: PropTypes.string.isRequired,
    resourceName: PropTypes.string.isRequired,
    resourceType: PropTypes.string
  }).isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  emailConfirmationEnabled: PropTypes.bool.isRequired,
  smsConfirmationEnabled: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  unit: PropTypes.shape({
    name: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    info: PropTypes.string
  }).isRequired,
  optionalReservationText: PropTypes.bool.isRequired
};

export default translate(['booking'])(ConfirmTimeSlotForm);



// WEBPACK FOOTER //
// ./src/components/ConfirmTimeSlotForm/index.jsx